<div class="title">
  <ng-content select="ui-card-subtitle, [ui-card-subtitle]"></ng-content>
  <span class="ui-card-title">
    <ng-content select="ui-card-title, [ui-card-title]"></ng-content>
  </span>
</div>
<div class="body">
  <ng-content></ng-content>
</div>
